export const isRedirectToUrlBtn = (dashboardBtnAction) => {
  return dashboardBtnAction && dashboardBtnAction?.value === 'RedirectToUrl';
};
